import Vue from "vue";
import Vuex from "vuex";

import adminclients from "./modules/admin/clients";
import adminincomedeclarations from "./modules/admin/incomedeclarations";
import admininvoices from "./modules/admin/invoices";
import adminusers from "./modules/admin/users";
import adminyeardata from "./modules/admin/yeardata";
import attachments from "./modules/attachments";
import errors from "./modules/errors";
import files from "./modules/files";
import incomedeclarations from "./modules/incomedeclarations";
import invoiceprevision from "./modules/invoiceprevision";
import invoices from "./modules/invoices";
import messages from "./modules/messages";
import popuphandler from "./modules/popuphandler";
import stats from "./modules/stats";
import systemmessages from "./modules/systemmessages";
import tenant from "./modules/tenant";
import user from "./modules/user";
import utilities from "./modules/utilities";

Vue.use(Vuex);

export const store = new Vuex.Store({
	modules: {
		adminclients,
		adminincomedeclarations,
		admininvoices,
		adminusers,
		adminyeardata,
		attachments,
		errors,
		files,
		incomedeclarations,
		invoiceprevision,
		invoices,
		messages,
		popuphandler,
		stats,
		systemmessages,
		tenant,
		user,
		utilities,
	},
});
